import { Component, Input } from '@angular/core';
import { OnlinePatientService } from '../services/online.patient.service';
import { OnlinePatient } from '../models/online.patient.model';
import { LookupService } from '../services/lookup.service';
import { NotificationService } from '../services/notification.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-online-patient-form',
  templateUrl: './online-patient-form.component.html'
})
export class OnlinePatientFormComponent {
  constructor(public lookupService: LookupService, public service: OnlinePatientService, private notificationService: NotificationService) { }

  @Input() model: OnlinePatient;

  options: any = { format: 'YYYY-MM-DD', maxDate: new Date() };

  ngOnInit() {

  }

  getCitiesByState(id) {
    this.lookupService.getCitiesByState(id);
  }

  onStateChanged(data: { value: string[] }): void {
    this.getCitiesByState(data);
  }

  submitted = false;

  onSubmit() {
    this.submitted = true;
    this.service.model = this.model;
    if (!this.model.onlinePatientID)
      this.insertRecord();
    else
      this.updateRecord();
  }


  insertRecord() {
    
    this.service.post().subscribe(
      res => {
        this.reset();
        this.notificationService.notifySuccess();
        this.service.search();
        $('#PanelForm, #PanelMain').slideToggle();
      },
      err => { console.log(err); }
    )
  }

  updateRecord() {

    this.service.put().subscribe(
      res => {
        this.reset();
        this.notificationService.notifySuccess();
        this.service.search();
        $('#PanelForm, #PanelMain').slideToggle();
      },
      err => {
        console.log(err);
      }
    )
  }

  // TODO: Remove this when we're done

  reset() {
    this.model = new OnlinePatient();
  }

}
 
